import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const BNK_STMT_saveBsDocUpload_API_CALL = createAsyncThunk(
  'BNK_STMT_saveBsDocUpload_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({
      type: 'BNK_STMT_saveBsDocUpload_API_CALL/pending',
      payload: {},
    });
    const { saveBsDocUploadPayload, successFn, errorFn } = payload;
    const {
      customerId,
      Authorization,
      customerRefNum,
      filePath,
      proofId,
      methodType,
      requestType,
      journeyType,
      password,
    } = saveBsDocUploadPayload;
    const { selectedBankObj, bankStatementPassword } =
      getState().bankStatementJourney;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/savedocumentdetails',
      payload: {
        proofId: 1,
        requestType: 'SAVE_BANK_STATEMENT',
        filePath: [...filePath],
        bankStatement: {
          instiId: selectedBankObj.institutionId,
          bankName: selectedBankObj.bankName,
          bankId: selectedBankObj.bankId,
        },
        customerId,
        customerRefNum,
        password: bankStatementPassword,
        journeyType: getState().bankStatementJourney.journeyTypeEnum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const saveBsDocuploadResponse = res;
        if (successFn) successFn(res);
        dispatch({
          type: 'BNK_STMT_saveBsDocUpload_API_CALL/fulfilled',
          payload: saveBsDocuploadResponse,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        if (errorFn) errorFn(err);
        dispatch({
          type: 'BNK_STMT_saveBsDocUpload_API_CALL/rejected',
          payload: err,
        });
      },
    });
  }
);

export const BNK_STMT_saveBsDocUpload_API_CALL_extrareducer = {
  [BNK_STMT_saveBsDocUpload_API_CALL.pending]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = true;
  },
  [BNK_STMT_saveBsDocUpload_API_CALL.fulfilled]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = false;

    state.saveBsDocUploadAPICall.isSuccess = true;
    state.saveBsDocUploadAPICall.isError = false;
    state.saveBsDocUploadAPICall.response = action.payload;
  },
  [BNK_STMT_saveBsDocUpload_API_CALL.rejected]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = false;

    state.saveBsDocUploadAPICall.isSuccess = false;
    state.saveBsDocUploadAPICall.isError = true;
    state.saveBsDocUploadAPICall.response = action.payload;
  },
};
